import { AuthProvider } from "@/contexts/auth-context"
import { PageProvider } from "@/contexts/page-context"
import { getUser } from "@/helpers/auth-helper"
import { Navigate, useLocation } from "react-router-dom"

const ProtectedRoute = ({ children }) => {
    const user = getUser()
    const location = useLocation()

    if (!user) {
        return <Navigate to="/login" state={{ back: location.pathname }} replace={true} />
    }

    return (
        <AuthProvider>
            <PageProvider>
                {children}
            </PageProvider>
        </AuthProvider>
    )
}

export default ProtectedRoute